var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var ClientPagePresenter = /** @class */ (function () {
    function ClientPagePresenter(actions, usecases) {
        this.actions = actions;
        this.usecases = usecases;
        this.clientSidebarOpen = false;
    }
    ClientPagePresenter.prototype.getfamilyDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.getfamilyDetailsUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getDpNomineeDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.dpNomineeDetailsUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getFnoConsentDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.platformFnoDetailsUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getADBDetailsData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.adbDetailsUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getBrokingADBDetailsData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.brokingADBDetailsUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getQRCDocDetailsData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.getQRCDocDetails.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getPaylinkReport = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.getPaylinkReport.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getHomogenousTierCurrentStatusData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.homogenousGetTierCurrentStatusUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getValidateParamsExchangeData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.validateParamsExchangeUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getValidateParams = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.validateParamsUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getAumInsuranceData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.aumInsuranceUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.deleteFamily = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.deleteFamilyUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getThirdPartyPOAData = function (accCode) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.getThirdPartyPOADetails.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, accCode);
        });
    };
    ClientPagePresenter.prototype.saveThirdPartyPOA = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.saveThirdPartyPOA.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.sendMandateMail = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.sendMandateMail.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getMandateSampleFile = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.getMandateSampleFile.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, null);
        });
    };
    ClientPagePresenter.prototype.getMandateDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.getMandateDetails.execute({
                onSuccess: function (mandate) {
                    return resolve(mandate.data);
                },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getValidateBank = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.getValidateBank.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    ClientPagePresenter.prototype.updatePlatformSMTFReq = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.updatePlatformSMTFRequest.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getRevenueFnoMarginData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.revenueFnoMargin.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getIncomeRange = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.incomeRange.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, null);
        });
    };
    ClientPagePresenter.prototype.getViewIncomeDeclarationSRDetails = function (accountCode) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.viewIncomeDeclarationSR.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, accountCode);
        });
    };
    ClientPagePresenter.prototype.getViewIncomeDeclarationDetails = function (accountCode) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.viewIncomeDeclaration.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, accountCode);
        });
    };
    ClientPagePresenter.prototype.getADBSchemeWiseDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.getADBSchemeWiseDetailsUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getClientSearchList = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.clientSearch.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getClientSearchData = function (req) {
        var _this = this;
        this.actions.clientSearch.hideError("ClientSearch");
        this.actions.clientSearch.loader("ClientSearch");
        this.usecases.clientSearch.execute({
            onSuccess: function (data) {
                _this.actions.clientSearch.getClientSearchData(data, "ClientSearch");
                _this.actions.clientSearch.stopLoader("ClientSearch");
            },
            onError: function (error) {
                _this.actions.clientSearch.setError({ isOpen: true, error: error }, "ClientSearch");
                _this.actions.clientSearch.stopLoader("ClientSearch");
            },
        }, req);
    };
    ClientPagePresenter.prototype.getClientHeaderAccCodeData = function (req) {
        var _this = this;
        this.actions.clientHeaderAccCode.hideError("ClientHeaderAccCode");
        this.actions.clientHeaderAccCode.loader("ClientHeaderAccCode");
        this.usecases.clientHeaderAccCode.execute({
            onSuccess: function (data) {
                _this.actions.clientHeaderAccCode.getClientHeaderAccCodeData(data, "ClientHeaderAccCode");
                _this.actions.clientHeaderAccCode.stopLoader("ClientHeaderAccCode");
            },
            onError: function (error) {
                _this.actions.clientHeaderAccCode.setError({ isOpen: true, error: error }, "ClientHeaderAccCode");
                _this.actions.clientHeaderAccCode.stopLoader("ClientHeaderAccCode");
            },
        }, req);
    };
    ClientPagePresenter.prototype.getClientOverviewData = function (req) {
        var _this = this;
        this.actions.clientOverview.hideError("ClientOverview");
        this.actions.clientOverview.loader("ClientOverview");
        this.usecases.clientOverview.execute({
            onSuccess: function (data) {
                _this.actions.clientOverview.getClientOverviewData(data, "ClientOverview");
                _this.actions.clientOverview.stopLoader("ClientOverview");
            },
            onError: function (error) {
                _this.actions.clientOverview.setError({ isOpen: true, error: error }, "ClientOverview");
                _this.actions.clientOverview.stopLoader("ClientOverview");
            },
        }, req);
    };
    ClientPagePresenter.prototype.getClientHeaderAUMData = function (req) {
        var _this = this;
        this.actions.clientHeaderAUM.hideError("clientHeaderAUM");
        this.actions.clientHeaderAUM.loader("clientHeaderAUM");
        this.usecases.clientHeaderAUM.execute({
            onSuccess: function (data) {
                _this.actions.clientHeaderAUM.getClientHeaderAUMData(data, "clientHeaderAUM");
                _this.actions.clientHeaderAUM.stopLoader("clientHeaderAUM");
            },
            onError: function (error) {
                _this.actions.clientHeaderAUM.setError({ isOpen: true, error: error }, "clientHeaderAUM");
                _this.actions.clientHeaderAUM.stopLoader("clientHeaderAUM");
            },
        }, req);
    };
    ClientPagePresenter.prototype.getClientMultipleContactsData = function (req) {
        var _this = this;
        this.actions.clientMultipleContent.hideError("ClientMultipleContact");
        this.actions.clientMultipleContent.loader("ClientMultipleContact");
        this.usecases.clientMultipleContent.execute({
            onSuccess: function (data) {
                _this.actions.clientMultipleContent.getClientMultipleContactsData(data, "ClientMultipleContact");
                _this.actions.clientMultipleContent.stopLoader("ClientMultipleContact");
            },
            onError: function (error) {
                _this.actions.clientMultipleContent.setError({ isOpen: true, error: error }, "ClientMultipleContact");
                _this.actions.clientMultipleContent.stopLoader("clientHeaderAUM");
            },
        }, req);
    };
    ClientPagePresenter.prototype.getClientMCAccessData = function (req) {
        var _this = this;
        this.actions.clientMCAccess.hideError("ClientMCAccess");
        this.actions.clientMCAccess.loader("ClientMCAccess");
        this.usecases.clientMCAccessUseCase.execute({
            onSuccess: function (data) {
                _this.actions.clientMCAccess.getClientMCAccessData(data, "ClientMCAccess");
                _this.actions.clientMCAccess.stopLoader("ClientMCAccess");
            },
            onError: function (error) {
                _this.actions.clientMCAccess.setError({ isOpen: true, error: error }, "ClientMCAccess");
                _this.actions.clientMCAccess.stopLoader("ClientMCAccess");
            },
        }, req);
    };
    ClientPagePresenter.prototype.getPasswordResentHistory = function (req) {
        var _this = this;
        this.actions.passwordResentHistory.hideError("PasswordResentHistory");
        this.actions.passwordResentHistory.loader("PasswordResentHistory");
        this.usecases.passwordResentHistoryUseCase.execute({
            onSuccess: function (data) {
                _this.actions.passwordResentHistory.getPasswordResentHistoryData(data, "PasswordResentHistory");
                _this.actions.passwordResentHistory.stopLoader("PasswordResentHistory");
            },
            onError: function (error) {
                _this.actions.passwordResentHistory.setError({ isOpen: true, error: error }, "PasswordResentHistory");
                _this.actions.passwordResentHistory.stopLoader("PasswordResentHistory");
            },
        }, req);
    };
    ClientPagePresenter.prototype.getOwnerHistoryData = function (req) {
        var _this = this;
        this.actions.ownerHistory.hideError("OwnerHistory");
        this.actions.ownerHistory.loader("OwnerHistory");
        this.usecases.ownerHistoryUseCase.execute({
            onSuccess: function (data) {
                _this.actions.ownerHistory.getOwnerHistoryData(data, "OwnerHistory");
                _this.actions.ownerHistory.stopLoader("OwnerHistory");
            },
            onError: function (error) {
                _this.actions.ownerHistory.setError({ isOpen: true, error: error }, "OwnerHistory");
                _this.actions.ownerHistory.stopLoader("OwnerHistory");
            },
        }, req);
    };
    ClientPagePresenter.prototype.getDpDetailsData = function (req) {
        var _this = this;
        this.actions.dpDetails.hideError("DPDetails");
        this.actions.dpDetails.loader("DPDetails");
        this.usecases.dpDetailsUseCase.execute({
            onSuccess: function (data) {
                _this.actions.dpDetails.getDpDetailsData(data, "DPDetails");
                _this.actions.dpDetails.stopLoader("DPDetails");
            },
            onError: function (error) {
                _this.actions.dpDetails.setError({ isOpen: true, error: error }, "DPDetails");
                _this.actions.dpDetails.stopLoader("DPDetails");
            },
        }, req);
    };
    ClientPagePresenter.prototype.getFamilyMemDetails = function (req) {
        var _this = this;
        this.actions.familyMemDetails.hideError("FamilyMemDetails");
        this.actions.familyMemDetails.loader("FamilyMemDetails");
        return new Promise(function (resolve, reject) {
            _this.usecases.familyMemDetailsUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                    _this.actions.familyMemDetails.getFamilyMemDetails(data, "FamilyMemDetails");
                    _this.actions.familyMemDetails.stopLoader("FamilyMemDetails");
                },
                onError: function (error) {
                    reject(error);
                    _this.actions.familyMemDetails.setError({ isOpen: true, error: error }, "FamilyMemDetails");
                    _this.actions.familyMemDetails.stopLoader("FamilyMemDetails");
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getBankDetailsData = function (req) {
        var _this = this;
        this.actions.bankDetails.hideError("BankDetails");
        this.actions.bankDetails.loader("BankDetails");
        this.usecases.bankDetailsUseCase.execute({
            onSuccess: function (data) {
                _this.actions.bankDetails.getBankDetailsData(data, "BankDetails");
                _this.actions.bankDetails.stopLoader("BankDetails");
            },
            onError: function (error) {
                _this.actions.bankDetails.setError({ isOpen: true, error: error }, "BankDetails");
                _this.actions.bankDetails.stopLoader("BankDetails");
            },
        }, req);
    };
    ClientPagePresenter.prototype.addFamilyMemDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.addfamilyMemDetails.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getPlatformsDetailsData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.platformsDetailsUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.deleteFamilyMember = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.deletefamilyMember.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getConsentDetailsData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.consentDetailsUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getUPIDetailsData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.upiDetailsUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getOwnersInformation = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.clientOwners.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getLOADetailsData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.loaDetailsUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getNPSDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.npsDetialUseCase.execute({
                onSuccess: function (data) {
                    console.log("data", data);
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getRevenueAUMData = function (req) {
        var _this = this;
        this.actions.revAUMData.hideError("AUMData");
        this.actions.revAUMData.loader("AUMData");
        this.usecases.aumData.execute({
            onSuccess: function (data) {
                _this.actions.revAUMData.getRevenueAUMData(data, "AUMData");
                _this.actions.revAUMData.stopLoader("AUMData");
            },
            onError: function (error) {
                _this.actions.revAUMData.setError({ isOpen: true, error: error }, "AUMData");
                _this.actions.revAUMData.stopLoader("AUMData");
            },
        }, req);
    };
    ClientPagePresenter.prototype.getRevenueActiveLoans = function (req) {
        var _this = this;
        this.actions.revActiveLoans.hideError("activeLoans");
        this.actions.revActiveLoans.loader("activeLoans");
        this.usecases.activeLoan.execute({
            onSuccess: function (data) {
                _this.actions.revActiveLoans.getRevenueActiveLoans(data, "activeLoans");
                _this.actions.revActiveLoans.stopLoader("activeLoans");
            },
            onError: function (error) {
                _this.actions.revActiveLoans.setError({ isOpen: true, error: error }, "activeLoans");
                _this.actions.revActiveLoans.stopLoader("activeLoans");
            },
        }, req);
    };
    ClientPagePresenter.prototype.getRevenueActiveLoanDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.activeLoanDetails.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getEligibilityDetailsData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.eligibilityDetailsUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getDPCDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.dpcDetailsUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getPastIntractionDetailsData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.pastIntractionDetailsUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getBrokVolumeDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.brokVolDetailsUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getThirdPartyPOADetailsData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.thirdPartyPOADetailsUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getBrokingPlanDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.brokingPlanUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getClientLifeCycleDetailsData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.clientLifeCycleDetailsUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getClientDpLedgerGetCatogeryDetailsData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.clientDpLedgerGetCatogeryDetailsUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getClientDpLedgerDetailsData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.clientDpLedgerDetailsUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getHistoricalViewData = function (req) {
        var _this = this;
        this.actions.historicalView.hideError("HistoricalView");
        this.actions.historicalView.loader("HistoricalView");
        this.usecases.historicalView.execute({
            onSuccess: function (data) {
                _this.actions.historicalView.getHistoricalViewData(data, "HistoricalView");
                _this.actions.historicalView.stopLoader("HistoricalView");
            },
            onError: function (error) {
                _this.actions.historicalView.setError({ isOpen: true, error: error }, "HistoricalView");
                _this.actions.historicalView.stopLoader("HistoricalView");
            },
        }, req);
    };
    ClientPagePresenter.prototype.getClientPassthroughData = function (req) {
        var _this = this;
        this.actions.clientPassthrough.hideError("ClientPassthrough");
        this.actions.clientPassthrough.loader("ClientPassthrough");
        this.usecases.clientPassthroughUseCase.execute({
            onSuccess: function (data) {
                _this.actions.clientPassthrough.getClientPassthroughData(data, "ClientPassthrough");
                _this.actions.clientPassthrough.stopLoader("ClientPassthrough");
            },
            onError: function (error) {
                _this.actions.clientPassthrough.setError({ isOpen: true, error: error }, "ClientPassthrough");
                _this.actions.clientPassthrough.stopLoader("ClientPassthrough");
            },
        }, req);
    };
    ClientPagePresenter.prototype.getClientBackOfficeUrlData = function (req) {
        var _this = this;
        this.actions.clientBackOfficeUrl.hideError("ClientBackOfficeUrl");
        this.actions.clientBackOfficeUrl.loader("ClientBackOfficeUrl");
        this.usecases.ClientBackOfficeUrlUseCase.execute({
            onSuccess: function (data) {
                _this.actions.clientBackOfficeUrl.getIClientBackOfficeUrlData(data, "ClientBackOfficeUrl");
                _this.actions.clientBackOfficeUrl.stopLoader("ClientBackOfficeUrl");
            },
            onError: function (error) {
                _this.actions.clientBackOfficeUrl.setError({ isOpen: true, error: error }, "ClientBackOfficeUrl");
                _this.actions.clientBackOfficeUrl.stopLoader("ClientBackOfficeUrl");
            },
        }, req);
    };
    ClientPagePresenter.prototype.getMFRegistrationBookData = function (req) {
        var _this = this;
        this.actions.mfRegistrationBook.hideError("MFRegistrationBook");
        this.actions.mfRegistrationBook.loader("MFRegistrationBook");
        this.usecases.MFRegistrationBookUseCase.execute({
            onSuccess: function (data) {
                _this.actions.mfRegistrationBook.getMFRagistrationBookData(data, "MFRegistrationBook");
                _this.actions.mfRegistrationBook.stopLoader("MFRegistrationBook");
            },
            onError: function (error) {
                _this.actions.mfRegistrationBook.setError({ isOpen: true, error: error }, "MFRegistrationBook");
                _this.actions.mfRegistrationBook.stopLoader("MFRegistrationBook");
            },
        }, req);
    };
    ClientPagePresenter.prototype.getMFOrderBookData = function (req) {
        var _this = this;
        if (req.downloadFlag) {
            return new Promise(function (resolve, reject) {
                _this.usecases.MFOrderBookUseCase.execute({
                    onSuccess: function (data) {
                        if (data && data.downloadMFResponseEntity)
                            resolve(data.downloadMFResponseEntity);
                    },
                    onError: function (error) {
                        reject(error);
                    },
                }, req);
            });
        }
        else {
            this.actions.mfOrderBook.hideError("MFOrderBook");
            this.actions.mfOrderBook.loader("MFOrderBook");
            this.usecases.MFOrderBookUseCase.execute({
                onSuccess: function (data) {
                    if (data && data.mflistResponseEntity) {
                        _this.actions.mfOrderBook.getMFOrderBookData(data.mflistResponseEntity, "MFOrderBook");
                    }
                    _this.actions.mfOrderBook.stopLoader("MFOrderBook");
                },
                onError: function (error) {
                    _this.actions.mfOrderBook.setError({ isOpen: true, error: error }, "MFOrderBook");
                    _this.actions.mfOrderBook.stopLoader("MFOrderBook");
                },
            }, req);
        }
    };
    ClientPagePresenter.prototype.getPayingDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.payingDetailsUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getAUMSummaryDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.aumSummaryDetailsUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getFNOMarginDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.fnoMarginDetailsUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getADBRenewalData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.adbRenewalUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getADBCurrentPlansData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.adbCurrentPlansUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getCurrentPlanData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.currentPlanUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getRevenueInsuranceData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.usecases.insuranceDataUseCase.execute({
                            onSuccess: function (data) {
                                resolve(data);
                            },
                            onError: function (error) {
                                reject(error);
                            },
                        }, req);
                    })];
            });
        });
    };
    ClientPagePresenter.prototype.getPaylinkReportDetailsData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.paylinkReportsDetailsUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getRevenueADBActiveoffer = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.usecases.adbActiveOfferUseCase.execute({
                            onSuccess: function (data) {
                                resolve(data);
                            },
                            onError: function (error) {
                                reject(error);
                            },
                        }, req);
                    })];
            });
        });
    };
    ClientPagePresenter.prototype.generatePaymentLink = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.generatePaymentLinkUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getRevenueADBExpiredoffer = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.usecases.adbExpiredOfferUseCase.execute({
                            onSuccess: function (data) {
                                resolve(data);
                            },
                            onError: function (error) {
                                reject(error);
                            },
                        }, req);
                    })];
            });
        });
    };
    ClientPagePresenter.prototype.getCountryCodeMasterData = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.getCountryCodeMasterDataUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, null);
        });
    };
    ClientPagePresenter.prototype.killPaymentLink = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.killPaymentLinkUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getMortageDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.getMortageDetailsUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                    // resolve(data.sort((a, b) => a.loanId - b.loanId));
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getRevenueADBFutureoffer = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.usecases.adbFutureOfferUseCase.execute({
                            onSuccess: function (data) {
                                resolve(data);
                            },
                            onError: function (error) {
                                reject(error);
                            },
                        }, req);
                    })];
            });
        });
    };
    ClientPagePresenter.prototype.saveMortageDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.saveMortageDetailsUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.clearSelectedClientData = function () {
        this.actions.clientSearch.setSelectedClient(null, "ClientSearch");
        this.actions.clientHeaderAccCode.getClientHeaderAccCodeData(null, "ClientHeaderAccCode");
    };
    ClientPagePresenter.prototype.setSelectedClientOnSearchClick = function (selected) {
        localStorage.setItem("client360SelectedClient", JSON.stringify(selected));
        this.actions.clientSearch.setSelectedClient(selected, "ClientSearch");
    };
    ClientPagePresenter.prototype.editUPIdetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.editUPIDetailsUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.clientAddContact = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.clientAddContactUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getPaylinkScenarioDetails = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.getPaylinkScenarioUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, null);
        });
    };
    ClientPagePresenter.prototype.getMasterRelation = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.masterRelation.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, null);
        });
    };
    ClientPagePresenter.prototype.addupiDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.addUPIDetails.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getDataFromQRC = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.getDataFromQRCUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getEmandateData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.eMandateData.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getRefIdData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.refIdData.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.incomeDeclarationGetClientType = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.incomeDeclarationGetClientTypeUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, null);
        });
    };
    ClientPagePresenter.prototype.incomeDeclarationGetNonClientType = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.incomeDeclarationGetNonClientTypeUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, null);
        });
    };
    ClientPagePresenter.prototype.getPlatformSMTFAcceptReject = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.getPlatformSMTFAcceptRejectUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getPlatformBSERequest = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.getPlatformBSERequestUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.requestMandate = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.requestMandate.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.deleteLOA = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.deleteLOA.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.sendLoaDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.sendLoaDetailsUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getBankDetailsMandateForms = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.getBankDetailsMandateFormsUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getBankBranchDetailsMandateForms = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.getBankBranchDetailsMandateFormsUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.postPlatformBSERequestAccept = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.postPlatformBSERequestUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.saveLoaDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.saveLoaDetailsUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.postPlatformBSEUpload = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.postPlatformBSEUploadUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.postPlatformReactivationLink = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.postPlatformReactivationLinkUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getRazorPayAccountDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.getRazorPayAccountDetailsUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getRazorPayTransactionDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.getRazorPayTransactionDetailsUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getSearchFamilyTagging = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.familyTaggingSearch.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getPastInteractionDownload = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.pastInteractionDownload.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getBrokingAccountDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.brokingAccount.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.downloadPrismReports = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.downloadPrismReports.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getPartnerStatus = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.getPartnerStatus.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getDPDetailsByDPId = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.getDPDetailsByDPId.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.sendOTP = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.sendOTP.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.verifyOTP = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.verifyOTP.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.saveIncomeDeclaration = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.saveIncomeDeclarationUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.postIncomeClientValidation = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.postIncomeClientValidation.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.postIncomeServiceRequest = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.postIncomeServiceRequest.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getPlanOffers = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.planOffers.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getSubTypeMaster = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.subTypeMaster.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.isClientSideBarOpen = function (value) {
        this.clientSidebarOpen = value;
    };
    ClientPagePresenter.prototype.getClientSideBarOpen = function () {
        return this.clientSidebarOpen;
    };
    ClientPagePresenter.prototype.getExceptionlsin = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.getExceptionlsin.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getExceptionData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.getExceptionData.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getExceptionSegment = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.getExceptionSegment.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.saveExceptionHaircut = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.saveExceptionHaircut.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getMFRegistrationBookAccodeData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.MFRegistrationBookAccodeUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.DNCSTD = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.dncStd.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, null);
        });
    };
    ClientPagePresenter.prototype.DNCPendingStatus = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.dncPendingStatus.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.DNCData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.dncData.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.POAEdis = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.poaEdis.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getFNOAvailableCashData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.getFNOAvailableCashData.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getCKYCDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.ckycDetails.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.deletePoaData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.deletePoaData.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.downloadKYCData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.downloadKYCData.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.saveCKYCDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.saveckycDetails.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.downloadCMLReports = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.downloadCMLReports.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getClientBrokCommDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.getClientBrokCommDetails.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getClientSubFeeDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.getClientBrokSubFeeDetails.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getClientTierList = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.getClientTierList.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getClientTierReasonList = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.getClientTierReasonList.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, null);
        });
    };
    ClientPagePresenter.prototype.saveHomogenousPostRMFeedback = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.saveHomogenousPostRMFeedback.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getTaskDetailsByTaskId = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.usecases.getTaskDetailsByTaskIdUseCase.execute({
                            onSuccess: function (data) {
                                resolve(data);
                            },
                            onError: function (error) {
                                reject(error);
                            },
                        }, req);
                    })];
            });
        });
    };
    ClientPagePresenter.prototype.getFamilyRelations = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.getFamilyRelationsUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getFamily = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.getFamilyUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.getFamilyMembers = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.getFamilyMembersUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.createFamily = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.createFamilyUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.updateFamilyName = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.updateFamilyNameUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.createFamilyMember = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.createFamilyMemberUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.createFamilyMemberMultiple = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.createFamilyMemberMultipleUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.removeFamily = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.removeFamilyUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.removeFamilyMember = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.removeFamilyMemberUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.clientFamilySearch = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.clientFamilySearchUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.exitFamily = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.exitFamilyUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.consentCancel = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.consentCancelUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.consentResend = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.consentResendUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.familyLinkingAccess = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.familyLinkingAccess.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.searchClientsByRmWithOwnClient = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.searchClientsByRmWithOwnClientUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                    _this.actions.clientSearch.stopLoader("ClientSearch");
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.validateClient = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.validateClient.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.recentClientSearchGet = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.recentClientSearchGetUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                    _this.actions.clientSearch.stopLoader("ClientSearch");
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ClientPagePresenter.prototype.recentClientSearchSave = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.recentClientSearchSaveUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                    _this.actions.clientSearch.stopLoader("ClientSearch");
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    return ClientPagePresenter;
}());
export default ClientPagePresenter;
